import colors from 'globals/colors'
import styled from 'styled-components'

export const ClientActionsWrapper = styled.div`
  margin-top: 6px;
  display: flex;
  flex-direction: column;
`

export const ActionLink = styled.a`
  line-height: 19px;
  color: ${colors.darkGrey};
  text-decoration: underline;
  font-weight: bold;
  margin-top: 16px;
  
  &:hover {
    color: ${colors.darkGrey};
  }
  
  & > svg {
    margin-left: 12px;
    margin-bottom: -1px; 
  }
`

export const LeaderAddress = styled.div`
  color: ${colors.steelGrey};
  margin-top: 16px;
`

export const Canceled = styled.div`
  line-height: 28px;
  color: ${colors.reddishPink};
  font-weight: 600;
  background: rgba(255, 52, 101, 0.2);
  border-radius: 4px;
  margin-top: 30px;
  padding: 0 15px;
  align-self: flex-start;
`
